<template>
    <div>
        <v-row>
            <!-- SELECIONAR CODPERLET -->
            <v-col cols="12" class="px-0">
                <PletivoVigente @on-select-perlet="onSelectPerlet" />
            </v-col>
        </v-row>
        <v-row class="py-3">
            <!-- <v-switch density="compact" inset color="success"
                style="float: right" dense v-model="somente_devidos"
                @update:modelValue="onChangeDevidos" true-value="1" false-value="0"
                :loading="$store.state.checklistdb.loading_id == 'loading-financeiro'"
                :disabled="$store.state.checklistdb.loading_id == 'loading-financeiro'"
                label="Somente devidos">
            </v-switch> -->
            <v-switch density="compact" inset color="success"
                style="float: right" dense v-model="devidos_emitidos"
                @update:modelValue="onChangeDevidos" true-value="1" false-value="0"
                :loading="$store.state.checklistdb.loading_id == 'loading-financeiro'"
                :disabled="$store.state.checklistdb.loading_id == 'loading-financeiro'"
                label="Devidos Emitidos">
            </v-switch>
            <v-select v-model="conectivo" :items="['E', 'OU']"
                class="mx-2"
                @update:modelValue="()=> { page = 1; fetchData() }"
                label="Conectivo"></v-select>
            <v-switch density="compact" inset color="success"
                style="float: right" dense v-model="devidos_isentos"
                @update:modelValue="onChangeDevidos" true-value="1" false-value="0"
                :loading="$store.state.checklistdb.loading_id == 'loading-financeiro'"
                :disabled="$store.state.checklistdb.loading_id == 'loading-financeiro'"
                label="Lan. Isentos">
            </v-switch>
            <v-spacer></v-spacer>
            <div>
                <v-btn @click="()=> { getListasFinanceiro({page: 1}) }"
                    :loading="$store.state.checklistdb.loading_id == 'loading-financeiro'">
                    <v-icon>mdi-refresh</v-icon> Carregar
                </v-btn>
            </div>

        </v-row>
        <v-row>
            {{listas.count}} Registros
        </v-row>
        <v-row>
            <v-data-table-virtual
                :headers="headers"
                :items="computedListas"
                item-value="id"
                :show-expand="true"
                :items-per-page="itemsPerPage"
                loading-text="Carregando..."
                no-data-text="Nenhum Registro"
                no-results-text="Nenhum resultado"
                :disabled="$store.state.checklistdb.loading_id == 'loading-financeiro'"
                :loading="$store.state.checklistdb.loading_id == 'loading-financeiro'"
            >
                <template #top>
                    <v-text-field
                        class="ma-2"
                        variant="outlined"
                        v-model="search"
                        hide-details
                        @keyup.enter="()=> { getListasFinanceiro({page: 1}) }"
                        placeholder="Pesquisar RA, Nome...">
                        <template #append-inner>
                            <v-btn @click="()=> { getListasFinanceiro({page: 1}) }"
                                :loading="$store.state.checklistdb.loading_id == 'loading-financeiro'">
                                <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </template>
                <!-- eslint-disable-next-line -->
                <template #item.devido_emitido="{ item }">
                    <div class="text--center">
                        <!-- TODO: @change mudou para @update:modelValue -->
                        <v-switch density="compact"
                            class="ma-0 pa-0"
                            @update:modelValue="onDevidoEmitido(item, item.devido_emitido)"
                            inset color="success"
                            :disabled="$store.state.checklistdb.loading_id == `update-lista-aluno-${item.id}`"
                            :loading="$store.state.checklistdb.loading_id == `update-lista-aluno-${item.id}`"
                            v-model="item.devido_emitido" hide-details
                            :label="item.devido_emitido === true ? 'S': 'N'">
                        </v-switch>
                    </div>
                </template>
                <!-- eslint-disable-next-line -->
                <template #item.lancamento_isento="{ item }">
                    <div class="text--center">
                        <!-- TODO: @change mudou para @update:modelValue -->
                        <v-switch density="compact"
                            class="ma-0 pa-0"
                            @update:modelValue="onLancIsento(item, item.lancamento_isento)"
                            inset color="success"
                            :disabled="$store.state.checklistdb.loading_id == `update-lista-aluno-${item.id}`"
                            :loading="$store.state.checklistdb.loading_id == `update-lista-aluno-${item.id}`"
                            v-model="item.lancamento_isento" hide-details
                            :label="item.lancamento_isento === true ? 'S': 'N'">
                        </v-switch>
                    </div>
                </template>
                <!-- eslint-disable-next-line -->
                <template #item.valor_total_devido_decimal="{ item }">
                    {{item.valor_total_devido_real}}
                </template>
                <template #expanded-row="{ columns, item }">
                    <td class="bg-grey" :colspan="columns.length">
                        <v-data-table density="compact"
                            class="custom-header-style-child pa-2"
                            :items="item.material_objects"
                            :headers="[
                                { title: 'Material', align: 'start', sortable: true, value: 'lista_material_object.material_object.descricao', width:'30%' },
                                { title: 'Recebidos', align: 'start', sortable: true, value: 'recebidos', width:'10%' },
                                { title: 'Status', align: 'center', sortable: true, value: 'status_entregue', width:'15%' },
                                { title: 'Devido', align: 'end', sortable: true, value: 'item_total_devido_real', width:'10' },
                            ]"
                            >
                            <!-- eslint-disable-next-line -->
                            <template #item.recebidos="{ item }">
                                {{item.qtde_entregue}}/{{item.lista_material_object.qtde_exigida}}
                            </template>
                            <!-- eslint-disable-next-line -->
                            <template #item.status_entregue="{ item }">
                                <v-chip density="compact"
                                        :color="status_to_label(item.status_entregue).color">
                                        <b>{{status_to_label(item.status_entregue).label}}</b>
                                    </v-chip>
                            </template>
                        </v-data-table>
                    </td>
                </template>
            </v-data-table-virtual>
        </v-row>
        <v-row>
            <v-col cols="12" sm="3">
                <v-select
                    label="Itens por página"
                    v-model="itemsPerPage"
                    :items="itemsPerPageOptions"
                    @update:modelValue="()=> { page = 1; fetchData() }"
                ></v-select>
            </v-col>
            
            <v-col cols="12" sm="9">
                <v-pagination
                    v-model="page"
                    show-first-last-page
                    :total-visible="5"
                    :length="Math.ceil(listas.count / itemsPerPage)"
                    @update:modelValue="fetchData"
                >
                </v-pagination>
            </v-col>
        </v-row>
        <helper-gdb text="Financeiro" v-if="$store.getters.StateAuthenticatedUser.is_superuser"/>
        <loading-gdb :dialog="['loading-materiais'].includes($store.state.checklistdb.loading_id)" text="Carregando materiais..."/>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PletivoVigente from './PletivoVigente.vue'
import ConfigService from '../../services/index'
const configService = new ConfigService()
configService
export default {
    name: 'CheckListDBFinanceiro',
    components: {
        PletivoVigente
    },
    data: () => ({
        conectivo: 'E',
        itemsPerPage: 10,
        itemsPerPageOptions: [
            {value: 1, title: '1'},
            {value: 2, title: '2'},
            {value: 3, title: '3'},
            {value: 5, title: '5'},
            {value: 10, title: '10'},
            {value: 25, title: '25'},
            {value: 50, title: '50'},
            {value: 100, title: '100'},
            {value: -1, title: 'Todos'}
        ],
        page: 1,
        search: '',
        somente_devidos: '1',
        devidos_emitidos: '0',
        devidos_isentos: '0',
        listas: {
            results: [],
            next: null,
            previous: null,
            count: 0
        },
        headers: [
            { title: 'RA', align: 'center', sortable: true, value: 'ra', width:'15%' },
            { title: 'Nome', align: 'start', sortable: true, value: 'nome', width:'40%' },
            { title: 'Perlet', align: 'center', sortable: true, value: 'lista_object.codperlet', width:'10%' },
            { title: 'Val. Devido', align: 'end', sortable: true, value: 'valor_total_devido_decimal', width:'20%'},
            { title: 'Devido Emitido?', align: 'center', sortable: true, value: 'devido_emitido', width:'10%'},
            { title: 'Lan. Isento?', align: 'center', sortable: true, value: 'lancamento_isento', width:'10%'},
        ],
        legenda_status_entrega: {
            NAO_ENTREGUE: {
                label: 'Não Entregue',
                color: 'grey'
            },
            ENTREGA_PARCIAL: {
                label: 'Parcial',
                color: 'info'
            },
            ENTREGUE_TOTAL: {
                label: 'Entregue',
                color: 'success'
            },
            ENTREGUE_SOBRA: {
                label: 'Em Excesso',
                color: 'success'
            },
            DESCONHECIDO: {
                label: 'Desconhecido',
                color: 'secondary'
            },
        },
        periodo_letivo: null
    }),
    mounted() {
    },
    methods: {
        async fetchData(){
            this.getListasFinanceiro()
        },
        onSelectPerlet(value){
            this.periodo_letivo = value
            if(this.periodo_letivo){
                this.getListasFinanceiro()
            }
        },
        onChangeDevidos(){
            this.page = 1
            this.getListasFinanceiro()
        },
        build_legenda_resume(material){
            return `${material.lista_material_object.material_object.descricao} - ${material.qtde_entregue}/${material.lista_material_object.qtde_exigida}`
        },
        ...mapActions([
            'GetCheckListFinanceiro',
            'UpdateCheckListListaAluno'
        ]),
        init(){
            if (this.periodo_letivo){
                this.getListasFinanceiro()
            }
        },
        async getListasFinanceiro(params={}){
            const payload = {
                page: this.page,
                page_size: this.itemsPerPage,
                devidos: this.somente_devidos,
                codperlet: this.periodo_letivo,
                devidos_emitidos: this.devidos_emitidos,
                devidos_isentos: this.devidos_isentos,
                search: this.search,
                conectivo: this.conectivo,
                ...params,
            }
            const listas = await this.GetCheckListFinanceiro(payload)
            this.listas = listas
        },
        async onDevidoEmitido(lista_aluno, value){
            
            const updated = await this.UpdateCheckListListaAluno({id: lista_aluno.id, devido_emitido: !value})
            if (!updated){
                alert('Falha ao atualizar status de Devido Emitido!')
                this.getListasFinanceiro()
            }
        },
        async onLancIsento(lista_aluno, value){
            const updated = await this.UpdateCheckListListaAluno({id: lista_aluno.id, lancamento_isento: !value})
            if (!updated){
                alert('Falha ao atualizar status de Lançamento Isento!')
                this.getListasFinanceiro()
            }
        },
        status_to_label(status){
            try{
                return this.legenda_status_entrega[status]
            }catch{
                return { label: 'Ops', color: 'grey' }
            }
        },
    },
    computed: {
        ...mapGetters(['StateCheckListMateriais', 'StateDark']),
        computedListas(){
            var listas = this.listas?.results || []
            if (this.search){
                listas = listas.filter(o =>
                    o.ra.toLowerCase().indexOf(this.search.toLowerCase()) !== -1 ||
                    o.nome.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
                )
            }
            return listas
        }
    }
}
</script>